import * as Yup from 'yup';

export const LoginSchema = (t: any) => Yup.object().shape({
  email: Yup.string()
    .email(t('noCorrectEmail'))
    .required(t('emailRequired')),
  pwd: Yup.string()
    .required(t('passwordRequired')),
});

